"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var Vulkan = function Vulkan(props) {
  var color = props.color,
      size = props.size,
      others = _objectWithoutPropertiesLoose(props, ["color", "size"]);

  return _react.default.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    fill: color,
    viewBox: "0 0 24 24"
  }, others), _react.default.createElement("path", {
    d: "M14.342 15.337h-.936v-2.991c.299.167.694.474.936.769v2.222zm-7.897 0H5.278l-1.523-4.706h1.061l1.048 3.309h.013l1.061-3.309h1.068l-1.561 4.706zm4.7 0h-.89v-.474h-.02a1.051 1.051 0 0 1-.462.429 1.36 1.36 0 0 1-.58.132 1.63 1.63 0 0 1-.616-.099.89.89 0 0 1-.379-.28 1.11 1.11 0 0 1-.195-.442 2.768 2.768 0 0 1-.056-.577V11.93h.936v1.925c0 .281.044.491.132.629.088.139.244.208.468.208.255 0 .439-.076.554-.227.114-.152.171-.401.171-.748v-1.786h.936l.001 3.406zm3.352-2.05l-.002-.132 1.18-1.226h1.108l-1.285 1.252 1.43 2.155h-1.134l-1.297-2.049zm2.602-.31c.013-.22.068-.402.165-.547a1.13 1.13 0 0 1 .369-.349 1.6 1.6 0 0 1 .504-.188 2.9 2.9 0 0 1 .564-.056c.171 0 .345.012.521.036.176.024.336.072.481.142.145.07.264.168.356.293.092.125.138.291.138.498v1.773c0 .154.009.301.026.442a.799.799 0 0 0 .092.316h-.949a1.32 1.32 0 0 1-.066-.329 1.208 1.208 0 0 1-.528.323 2.135 2.135 0 0 1-.62.092c-.163 0-.314-.02-.455-.059a1.018 1.018 0 0 1-.369-.185.856.856 0 0 1-.247-.316 1.073 1.073 0 0 1-.089-.455c0-.193.034-.353.102-.478a.856.856 0 0 1 .264-.3c.108-.075.231-.131.369-.168.138-.037.278-.067.418-.089a7.99 7.99 0 0 1 .415-.053c.136-.013.257-.033.362-.059a.637.637 0 0 0 .251-.116c.062-.051.09-.124.086-.221a.5.5 0 0 0-.05-.241.365.365 0 0 0-.132-.138.521.521 0 0 0-.191-.066 1.56 1.56 0 0 0-.234-.017c-.185 0-.33.039-.435.119-.105.079-.167.211-.185.396h-.933zm2.162.693a.415.415 0 0 1-.148.082c-.059.02-.123.036-.191.05a3.21 3.21 0 0 1-.214.033c-.075.009-.149.02-.224.033-.07.013-.14.031-.208.053a.618.618 0 0 0-.178.089.42.42 0 0 0-.122.142.455.455 0 0 0-.046.218c0 .084.015.154.046.211a.362.362 0 0 0 .125.135.523.523 0 0 0 .185.069c.07.013.143.02.218.02.185 0 .328-.031.429-.092a.616.616 0 0 0 .224-.221.712.712 0 0 0 .089-.26c.011-.088.016-.158.017-.211l-.002-.351zm1.542-1.741h.89v.474h.02c.119-.198.272-.342.461-.432.189-.09.382-.135.58-.135.251 0 .456.034.617.102.16.068.286.163.379.283.092.121.157.268.194.441.037.176.056.368.056.579v2.096h-.936v-1.925c0-.281-.044-.491-.132-.629-.088-.138-.244-.208-.468-.208-.255 0-.439.076-.554.227-.114.151-.171.401-.171.748v1.786h-.936v-3.407zm-9.038-.587v3.996h.936v-3.48a11.577 11.577 0 0 0-.936-.516zm-9.548.17c.542-1.59 3.786-2.172 7.246-1.302 2.075.522 3.771 1.534 4.879 2.535-.503-1.327-2.94-3.22-6.295-3.868C4.253 8.143.511 8.788.048 10.472c-.334 1.216 1.134 2.641 3.406 3.615-1.021-.827-1.518-1.755-1.237-2.575zm12.126.655v-1.536h-.936v.466c.399.357.716.72.936 1.07z"
  }));
};

Vulkan.propTypes = {
  /**
   * Hex color or color name
   */
  color: _propTypes.default.string,

  /**
   * The size of the Icon.
   */
  size: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number])
};
Vulkan.defaultProps = {
  color: 'currentColor',
  size: '24'
};
var _default = Vulkan;
exports.default = _default;